import React from "react";
import { useCommandRelayContext } from "./CommandRelayProvider";
import { useAuthStore } from "store/auth";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";

interface CommandRelayButtonProps {
  className?: string;
}

// Only these usernames can see the Command button
const ALLOWED_USERNAMES = ["akash"];

export default function CommandRelayButton({ className = "" }: CommandRelayButtonProps) {
  const { status, onlineUsers, currentUser, openSender } = useCommandRelayContext();
  const { user } = useAuthStore();

  const isConnected = status === "connected";
  const otherUsersCount = onlineUsers.filter((u) => u.id !== currentUser?.id).length;

  // Only show button for allowed usernames (check auth store user, not WS user)
  if (!user || !ALLOWED_USERNAMES.includes(user.username?.toLowerCase() || "")) {
    return null;
  }

  return (
    <button
      onClick={openSender}
      className={`relative group flex items-center gap-2 px-3 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium transition-colors ${className}`}
      title="Send Command to Online User"
    >
      <PaperAirplaneIcon className="w-5 h-5" />
      <span className="hidden sm:inline">Command</span>
      
      {/* Connection indicator */}
      <span
        className={`absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-bold ${
          isConnected
            ? "bg-green-500 text-white"
            : "bg-red-500 text-white"
        }`}
      >
        {isConnected ? otherUsersCount : "!"}
      </span>

      {/* Tooltip */}
      <span className="absolute top-full right-0 mt-2 hidden group-hover:block z-50">
        <span className="block whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white shadow-lg">
          {isConnected
            ? `${otherUsersCount} user${otherUsersCount !== 1 ? "s" : ""} online`
            : "Disconnected"}
        </span>
      </span>
    </button>
  );
}
